<!-- eslint-disable prettier/prettier -->
<!-- eslint-disable prettier/prettier -->
<script setup>
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
// // 引入swiper样式（按需导入）
// import "swiper/css/pagination"; // 轮播图底面的小圆点
// import "swiper/css/navigation"; // 轮播图两边的左右箭头
// // import 'swiper/css/scrollbar'  // 轮播图的滚动条， 轮播图里一般不怎么会使用到滚动条，如果有用到的话import导入就行
// // 引入swiper核心和所需模块
// import { Autoplay, Navigation, Pagination, Scrollbar } from "swiper";
//
// // 在modules加入要使用的模块
// const modules = [Autoplay, Pagination, Navigation, Scrollbar];
//
const index = ref(0);
const jumpTo = (url, num) => {
  index.value = num;
  router.push(url);
};
onMounted(() => {
  switch (window.location.pathname) {
    case "/about":
      index.value = 1;
      break;
    case "/product":
      index.value = 2;
      break;
    case "/certificate":
      index.value = 3;
      break;
    case "/contact":
      index.value = 4;
      break;
    default:
      index.value = 0;
  }
});
// // 更改当前活动swiper
// const onSlideChange = (swiper) => {
//   // swiper是当前轮播的对象，里面可以获取到当前swiper的所有信息，当前索引是activeIndex
//   console.log(swiper.activeIndex);
// };
</script>
<template>
  <div class="home">
    <nav>
      <!--    <router-link to="/">Home</router-link> |-->
      <!--    <router-link to="/about">About</router-link>-->
      <div class="head container">
        <img alt="" src="@/assets/logo.png" />
        <div class="menu">
          <div :class="{ active: index === 0 }" @click="jumpTo('/', 0)">
            <div>首页</div>
            <div>Home</div>
          </div>
          <div :class="{ active: index === 1 }" @click="jumpTo('/about', 1)">
            <div>公司简介</div>
            <div>Company Profile</div>
          </div>
          <div :class="{ active: index === 2 }" @click="jumpTo('/product', 2)">
            <div>产品中心</div>
            <div>Product Cente</div>
          </div>
          <div
            :class="{ active: index === 3 }"
            @click="jumpTo('/certificate', 3)"
          >
            <div>资质证书</div>
            <div>Qualification certificate</div>
          </div>
          <div :class="{ active: index === 4 }" @click="jumpTo('/contact', 4)">
            <div>联系我们</div>
            <div>Contact Us</div>
          </div>
        </div>
      </div>
    </nav>
    <div class="swiperTwo">
      <!--    <swiper-->
      <!--      :autoplay="true"-->
      <!--      :fadeEffect="{ crossFade: true }"-->
      <!--      :loop="true"-->
      <!--      :modules="modules"-->
      <!--      :noSwiping="true"-->
      <!--      :pagination="{ clickable: true }"-->
      <!--      :scrollbar="{ draggable: false }"-->
      <!--      :slides-per-view="1"-->
      <!--      :space-between="50"-->
      <!--      class="swiperBox"-->
      <!--      effect="fade"-->
      <!--      @slideChange="onSlideChange"-->
      <!--    >-->
      <!--      <swiper-slide v-for="i in 3" :key="i" style="height: 620px">-->
      <!--        <img-->
      <!--          alt=""-->
      <!--          src="@/assets/imgs/banner1.png"-->
      <!--          style="width: 100%; height: 100%"-->
      <!--        />-->
      <!--      </swiper-slide>-->
      <!--    </swiper>-->
      <div>
        <!--        <img alt="" src="@/assets/imgs/bannerBj.png" />-->
        <div class="tips">
          <div>
            <span>诚信</span>
            铸就
            <span>品质</span>&nbsp;
            <span>创新</span>
            引领
            <span>未来</span>
          </div>
          <div></div>
          <div>
            范围：储丝箱/贮丝箱、高端木托盘、进口原木、进口集成材、集成材加工
          </div>
        </div>
      </div>
    </div>
    <router-view />
    <div class="foot">
      <div class="container">
        <img alt="" src="@/assets/imgs/logo.png" />
        <div>
          <div>关于我们</div>
          <div @click="jumpTo('/about', 1)">公司简介</div>
          <div @click="jumpTo('/product', 2)">产品中心</div>
          <div @click="jumpTo('/certificate', 3)">资质证书</div>
          <div @click="jumpTo('/contact', 4)">联系我们</div>
        </div>
        <div>
          <div>联系我们</div>
          <div>地&nbsp;&nbsp;&nbsp;址：上海闵行区七莘路1809号2号楼2204室</div>
          <div>电&nbsp;&nbsp;&nbsp;话：021-37601447</div>
          <div>邮&nbsp;&nbsp;&nbsp;箱：office@tianjuewood.com</div>
          <div>&nbsp;</div>
        </div>
      </div>
      <div class="container" style="text-align: center">
        沪公网安备31011202020383号 沪ICP备14044778号 | 上海天爵木业有限公司
      </div>
    </div>
  </div>
</template>

<style lang="less">
html,
body,
p {
  padding: 0;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.home {
  padding-bottom: 270px;
  padding-top: 126px;
  position: relative;
}

nav {
  height: 126px;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 100;
  background: #fff;
  border-bottom: 1px solid rgba(44, 62, 80, 0.3);
}

.container {
  width: 1200px;
  margin: 0 auto;
}

.head {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;

  > img {
    width: 238px;
    height: 95px;
  }

  .menu {
    width: 800px;
    height: 100%;
    display: flex;
    justify-content: space-between;

    > div {
      flex: 1;
      cursor: pointer;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      border-bottom: 2px solid transparent;

      > div:first-child {
        margin-bottom: 14px;
        //font-family: Source Han Sans CN;
        font-size: 18px;
      }

      > div:nth-child(2) {
        //font-family: Adobe Heiti Std;
        font-size: 12px;
      }
    }

    .active {
      color: #2b3a86;
      border-bottom: 2px solid #2b3a86;

      > div {
        font-weight: 600;
      }
    }
  }
}

.swiperTwo {
  > div:first-child {
    height: 500px;
    background: url("@/assets/imgs/bannerBj.png") no-repeat;
    background-size: cover;
    padding: 100px 0;
    box-sizing: border-box;

    .tips {
      width: 723px;
      height: 300px;
      margin: 0 auto;
      border-radius: 10px;
      color: #fff;
      box-sizing: border-box;

      > div:first-child {
        font-size: 50px;

        span {
          color: #e69a15;
          font-weight: 600;
        }
      }

      > div:nth-child(3) {
        margin-top: 50px;
        text-align: left;
        padding-left: 20px;
        font-size: 24px;
      }

      > div:nth-child(2) {
        height: 5px;
        border-top: 1px solid #fff;
        border-bottom: 1px solid #fff;
        //border-radius: 10px;
        //background-color: #fff;
        //width: 200px;
        margin-top: 30px;
        //margin-left: 20px;
      }
    }
  }
}

.foot {
  height: 270px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 100;
  background: #2b3a86;
  color: #fff;

  > div:first-child {
    height: 230px;
    display: flex;
    justify-content: space-around;
    align-items: center;

    > img {
      width: 358px;
      height: 129px;
    }

    > div {
      text-align: left;

      > div {
        font-size: 14px;
        margin-bottom: 10px;
      }

      > div:first-child {
        font-size: 18px;
        margin-bottom: 30px;
      }
    }

    > div:nth-child(2) {
      > div {
        cursor: pointer;
      }
    }
  }

  > div:nth-child(2) {
    height: 40px;
    line-height: 40px;
  }
}
</style>
<script setup></script>
